// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { serverUrl } from '../../serverUrl';

// // 🔹 Register User
// export const registerUser = createAsyncThunk(
//   'auth/registerUser',
//   async (userData, { rejectWithValue }) => {
//     try {
//       const response = await serverUrl.post('users/register/', userData);
//       return response.data;
//     } catch (error) {
//       console.error('Registration Error:', error);

//       // Safely extract the message
//       const errorData = error.response?.data;
//       let message = 'Something went wrong';

//       if (errorData?.email && Array.isArray(errorData.email)) {
//         message = errorData.email[0]; // ✅ first error message string
//       } else if (errorData?.detail) {
//         message = errorData.detail;
//       }

//       return rejectWithValue(message);
//     }
//   }
// );

// // 🔹 Login User
// export const loginUser = createAsyncThunk(
//   'auth/loginUser',
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await serverUrl.post('users/login/', formData);
//       console.log('Login Response:', response.data);
//       localStorage.setItem('access_token', response.data.access);
//       localStorage.setItem('refresh_token', response.data.refresh);
//       localStorage.setItem('role', response.data.role);
//       localStorage.setItem('full_name', response.data.full_name);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Login failed');
//     }
//   }
// );

// // reset password
// export const resetPassword = createAsyncThunk(
//   'auth/resetPassword',
//   async (resetPasswordData, { rejectWithValue }) => {
//     try {
//       const { uidb64, token, new_password1, new_password2 } = resetPasswordData;

//       const response = await serverUrl.post(`users/reset/${uidb64}/${token}/`, {
//         new_password1,
//         new_password2,
//       });

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Password reset failed');
//     }
//   }
// );

// export const forgotPassword = createAsyncThunk(
//   'auth/forgotPassword',
//   async (emailData, { rejectWithValue }) => {
//     try {
//       const response = await serverUrl.post(
//         'users/forgot-password/',
//         emailData
//       );
//       console.log('Forgot Password Response:', response.data);
//       return response.data;
//     } catch (error) {
//       //   console.log('Forgot Password Error:', error.response?.data);
//       return rejectWithValue(
//         error.response?.data?.non_field_errors?.[0] || 'Request failed'
//       );
//     }
//   }
// );

// // 🔹 Slice
// const authSlice = createSlice({
//   name: 'auth',
//   initialState: {
//     user: null,
//     loading: false,
//     error: null,
//     isAuthenticated: !!localStorage.getItem('access_token'),
//   },
//   reducers: {
//     logout: (state) => {
//       state.user = null;
//       state.isAuthenticated = false;
//       localStorage.removeItem('access_token');
//       localStorage.removeItem('refresh_token');
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Register
//       .addCase(registerUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(registerUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = action.payload;
//       })
//       .addCase(registerUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })

//       // Login
//       .addCase(loginUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.user = action.payload;
//         state.isAuthenticated = true;
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       // Reset Password
//       .addCase(resetPassword.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(resetPassword.fulfilled, (state) => {
//         state.loading = false;
//         state.success = true; // indicate password reset succeeded
//       })
//       .addCase(resetPassword.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//         state.success = false;
//       });
//   },
// });

// export const { logout } = authSlice.actions;
// export default authSlice.reducer;


// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serverUrl } from '../../serverUrl';

// 🔹 Register User
export const registerUser = createAsyncThunk(
  'auth/registerUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post('users/register/', userData);
      return response.data;
    } catch (error) {
      console.error('Registration Error:', error);

      const errorData = error.response?.data;
      let message = 'Something went wrong';

      if (errorData?.email && Array.isArray(errorData.email)) {
        message = errorData.email[0];
      } else if (errorData?.detail) {
        message = errorData.detail;
      }

      return rejectWithValue(message);
    }
  }
);

// 🔹 Login User - OTP Always Required
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post('users/login/', formData);
      console.log('Login Response:', response.data);
      
      // OTP is always required - never save tokens here
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Login failed');
    }
  }
);

// 🔹 Verify OTP
export const verifyOTP = createAsyncThunk(
  'auth/verifyOTP',
  async ({ challenge_id, otp }, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post('users/verify-otp/', {
        challenge_id,
        otp
      });
      console.log('OTP Verification Response:', response.data);
      
      // Save tokens only after successful OTP verification
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      localStorage.setItem('role', response.data.user.role);
      localStorage.setItem('full_name', response.data.user.full_name);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'OTP verification failed');
    }
  }
);

// 🔹 Resend OTP
export const resendOTP = createAsyncThunk(
  'auth/resendOTP',
  async ({ challenge_id }, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post(
        'users/resend-otp/',
        { challenge_id }
      );

      console.log('Resend OTP Response:', response.data);

      return response.data;
    } catch (error) {
      console.error('Resend OTP Error:', error.response?.data);

      return rejectWithValue(
        error.response?.data || 'Failed to resend OTP'
      );
    }
  }
);

// 🔹 Reset Password
export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (resetPasswordData, { rejectWithValue }) => {
    try {
      const { uidb64, token, new_password1, new_password2 } = resetPasswordData;

      const response = await serverUrl.post(`users/reset/${uidb64}/${token}/`, {
        new_password1,
        new_password2,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Password reset failed');
    }
  }
);

// 🔹 Forgot Password
export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post(
        'users/forgot-password/',
        emailData
      );
      console.log('Forgot Password Response:', response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.non_field_errors?.[0] || 'Request failed'
      );
    }
  }
);

// 🔹 Slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem('access_token'),
    // OTP specific states
    otpRequired: false,
    challengeId: null,
    email: null,
    resendLoading: false,
    verifyLoading: false,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.otpRequired = false;
      state.challengeId = null;
      state.email = null;
      state.error = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('role');
      localStorage.removeItem('full_name');
      localStorage.removeItem('fcm_token');
    },
    clearOTPState: (state) => {
      state.otpRequired = false;
      state.challengeId = null;
      state.email = null;
      state.error = null;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Login - OTP Always Required
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.otpRequired = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        
        // OTP is always required
        state.otpRequired = true;
        state.challengeId = action.payload.challenge_id;
        state.email = action.payload.email;
        state.user = null;
        state.isAuthenticated = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.otpRequired = false;
      })

      // Verify OTP
      .addCase(verifyOTP.pending, (state) => {
        state.verifyLoading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.verifyLoading = false;
        state.user = action.payload.user;
        state.isAuthenticated = true;
        state.otpRequired = false;
        state.challengeId = null;
        state.email = null;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.verifyLoading = false;
        state.error = action.payload;
      })

      // Resend OTP
      .addCase(resendOTP.pending, (state) => {
        state.resendLoading = true;
        state.error = null;
      })
      .addCase(resendOTP.fulfilled, (state, action) => {
        state.resendLoading = false;
        if (action.payload.challenge_id) {
          state.challengeId = action.payload.challenge_id;
        }
        state.error = null;
      })
      .addCase(resendOTP.rejected, (state, action) => {
        state.resendLoading = false;
        state.error = action.payload;
      })

      // Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { logout, clearOTPState, clearAuthError } = authSlice.actions;
export default authSlice.reducer;